import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { COUNTRY_BY_CODE } from "@/data/countries";

const KEY = "wofy.country";

const CountryContext = createContext({ code: null, country: null, setCode: () => {}, clear: () => {} });

export function CountryProvider({ children }) {
  const [code, setCodeState] = useState(() => {
    try { return localStorage.getItem(KEY) || null; } catch { return null; }
  });

  const setCode = useCallback((c) => {
    const next = c || null;
    setCodeState(next);
    try {
      if (next) localStorage.setItem(KEY, next);
      else localStorage.removeItem(KEY);
    } catch { /* ignore */ }
  }, []);

  const clear = useCallback(() => setCode(null), [setCode]);

  // React to external changes (multi-tab)
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === KEY) setCodeState(e.newValue || null);
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const country = code ? COUNTRY_BY_CODE[code] || null : null;

  return (
    <CountryContext.Provider value={{ code, country, setCode, clear }}>
      {children}
    </CountryContext.Provider>
  );
}

export const useCountry = () => useContext(CountryContext);
